"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("./NotFound.css");

var _react = _interopRequireDefault(require("react"));

var _SessionPageContent = _interopRequireDefault(require("../components/SessionPageContent"));

var _MobxView = _interopRequireDefault(require("../../higher-order/MobxView"));

var _ContentItem = _interopRequireWildcard(require("../../shared/components/cms/ContentItem"));

var _mobxReact = require("mobx-react");

var _constants = require("../../util/constants");

var _SessionPageLogo = _interopRequireDefault(require("../components/SessionPageLogo"));

var _Propulator = _interopRequireDefault(require("../../higher-order/Propulator"));

var _class;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var NotFound = (0, _mobxReact.observer)(_class = /*#__PURE__*/function (_React$Component) {
  _inherits(NotFound, _React$Component);

  var _super = _createSuper(NotFound);

  function NotFound() {
    _classCallCheck(this, NotFound);

    return _super.apply(this, arguments);
  }

  _createClass(NotFound, [{
    key: "render",
    value: function render() {
      var _this$props$session;

      var stringFormatArgs = {
        HomeUrl: _ContentItem.ContentItemUtilities.stringifyComponent( /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("a", {
          className: "get-started-link highlighted",
          href: _constants.URLS.HOME
        }, "Gradifi.com"))),
        ContactUrl: _ContentItem.ContentItemUtilities.stringifyComponent( /*#__PURE__*/_react.default.createElement("a", {
          className: "contact-link highlighted",
          href: _constants.URLS.MARKETING.CONTACT
        }, "contact us"))
      };
      return /*#__PURE__*/_react.default.createElement(_SessionPageContent.default, null, /*#__PURE__*/_react.default.createElement(_SessionPageLogo.default, {
        baseAddress: (_this$props$session = this.props.session) === null || _this$props$session === void 0 ? void 0 : _this$props$session.baseAddress
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        className: "not-found-header",
        contentKey: "notFoundHeader",
        tag: "h1"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        className: "not-found-subheader",
        contentKey: "notFoundSubheader",
        tag: "p"
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "assistance"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "can-do-wrapper"
      }, /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        className: "can-do-header",
        contentKey: "canDoHeader",
        tag: "h3"
      }), /*#__PURE__*/_react.default.createElement("ul", {
        className: "can-do-list"
      }, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("div", {
        className: "can-do-bullet-1"
      }, /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        className: "can-do-text-1",
        contentKey: "canDoText1",
        stringFormatArgs: stringFormatArgs
      }))), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        className: "can-do-text-2",
        contentKey: "canDoText2"
      })), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        className: "can-do-text-3",
        contentKey: "canDoText3"
      })))), /*#__PURE__*/_react.default.createElement("div", {
        className: "need-help-wrapper"
      }, /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        className: "need-help-header",
        contentKey: "helpHeader",
        tag: "h3"
      }), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        className: "help-text",
        contentKey: "helpText",
        stringFormatArgs: stringFormatArgs
      })))));
    }
  }]);

  return NotFound;
}(_react.default.Component)) || _class;

var propulatedView = (0, _Propulator.default)(NotFound);

var _default = (0, _MobxView.default)(propulatedView);

exports.default = _default;